import { render, staticRenderFns } from "./campaign-base-info.vue?vue&type=template&id=43dee42e&scoped=true&"
import script from "./campaign-base-info.vue?vue&type=script&lang=js&"
export * from "./campaign-base-info.vue?vue&type=script&lang=js&"
import style0 from "./campaign-base-info.vue?vue&type=style&index=0&id=43dee42e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dee42e",
  null
  
)

export default component.exports